const ITEMS = [
  "24/7 Emergency Response",
  "Water · Fire · Mold · Storm",
  "IICRC Certified Crews",
  "Chicagoland's Trusted Experts",
  "Insurance Claim Support",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <section className="relative border-y border-white/10 bg-[#0a0a0a] py-6 overflow-hidden" data-testid="marquee">
      <div className="marquee-track">
        {row.map((t, i) => (
          <div key={i} className="flex items-center shrink-0">
            <span className="font-display text-2xl sm:text-3xl px-8 text-[#F5F5F0]">{t}</span>
            <span className="text-gold text-2xl">✦</span>
          </div>
        ))}
      </div>
    </section>
  );
}
